import { useQuery } from '@tanstack/vue-query'
import { useHttp } from '@/shared/lib'
import { computed, type Ref } from 'vue'

/**
 * Функция загрузки списка типов объектов
 */
export const useLoadInventoryObjectTypes = (filter: Ref<any>, objectId: Ref<number | string>) => {
  const http = useHttp()

  const queryKey = computed(() => ['load_inventory_object_types', objectId])

  const url = computed(() => {
    const searchParams = new URLSearchParams()
    Object.entries(filter.value).forEach(([k, v]) => {
      if (v !== undefined) searchParams.set(k, String(v))
    })
    return `/inventory/group/${objectId.value}/object-types?${searchParams}`
  })

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
    enabled: false,
  })
}

/**
 * Функция загрузки списка определенного типа объектов
 */
export const useLoadInventObjectType = (
  objectTypeId: Ref<string | number>,
  objectId: Ref<string>,
) => {
  const http = useHttp()

  const queryKey = computed(() => ['load_invent_object_type', objectId, objectTypeId])
  const url = computed(
    () => `/inventory/group/${objectId.value}/object-types/${objectTypeId.value}`,
  )

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
    enabled: computed(() => Boolean(objectTypeId.value)),
  })
}
